import Icon from '../components/Icon.vue'

Icon.register({
  'bell-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M633.8 458.1L543.2 388.1C543.4 386.7 544 385.4 544 384 544 376.4 541.4 368.7 535.4 362.3 516.1 341.5 479.9 310.3 479.9 208 479.9 130.3 425.4 68.1 352 52.8V32C352 14.3 337.7 0 320 0S288 14.3 288 32V52.8C247.7 61.2 213.4 83.9 190.4 115.4L45.5 3.4C38.5-2.1 28.4-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.5 6.2 53.9L594.5 508.6C601.5 514.1 611.6 512.8 617 505.8L636.6 480.6C642 473.6 640.8 463.5 633.8 458.1zM157.2 251.5C148.6 319.5 120.8 344.9 104.6 362.3 98.6 368.7 96 376.4 96 384 96.1 400.4 109 416 128.1 416H370L157.2 251.5zM320 512C355.3 512 384 483.4 384 448H256C256 483.4 284.7 512 320 512z'
      }
    ]
  }
})
